// extracted by mini-css-extract-plugin
export var pillWrapper = "_pm-0";
export var showOverflow = "_pm-1";